/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';
import { AssetDataDto } from './assetDataDto';

/**
 * Volume statistic dto
 */
export interface VolumeStatisticDto {
  account: Account;
  volumeInUsd: number;
  revenueInUsd: number;
  fullyHedged: boolean;
  assetData: Array<AssetDataDto>;
}
